import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import HomeworkRow from "./HomeworkRow";
import { webUrlNode } from "../../../constants/appInfo";

import { useParams } from "react-router-dom";
export default function HomeworkPopUp({ onClose }) {

    const {batchId} = useParams();
  const [items,setItems] = useState([]);
  const [linkedMap,setLinkedMap] = useState({});
  const [loading,setLoading] = useState(false);

  const AppToken = useSelector((s)=>s?.app?.app?.AppToken);
  const coursePostId = useSelector((s)=>s?.course?.course?.postId);
  const currentToken = useSelector((s)=>s?.user?.user?.token);

  useEffect(()=>{
    if(!coursePostId || !batchId) return;
    loadData();
  },[coursePostId,batchId]);


  async function loadData(){

    setLoading(true);

    try{

      // 1️⃣ Fetch all homeworks
      const hwRes = await axios.get(
        `${webUrlNode}/api/homework`,
        {
          params:{
            appToken:AppToken,
            coursePostId,
            currentToken
          }
        }
      );

      const homework = hwRes.data.items || [];
      setItems(homework);


      // 2️⃣ Fetch linked homeworks
      const linkRes = await axios.get(
        `${webUrlNode}/api/batches/${batchId}/homework`,
        {
          params:{appToken:AppToken}
        }
      );

      const linked = linkRes.data.items || [];

      const map = {};

      linked.forEach((row)=>{
        map[row.homeworkId] = {
          id:row.id,
          releaseAt: row.releaseAt ? row.releaseAt.split("T")[0] : "",
          dueAt: row.dueAt ? row.dueAt.split("T")[0] : ""
        };
      });

      setLinkedMap(map);

    }
    catch(e){
      console.error(e);
    }

    setLoading(false);

  }


  return(

    <div style={modalWrapper}>

      <div style={modalStyle}>

        <div className="modalHeader">
          <h3>Link Homework to Batch</h3>
          <button className="closeBtn" onClick={onClose}>✕</button>
        </div>

        {loading && <div>Loading...</div>}

        {!loading && items.map((hw,i)=>{

          const checked = !!linkedMap[hw.id];

          return(
            <HomeworkRow
              key={hw.id}
              homework={hw}
              index={i}
              batchId={batchId}
              checked={checked}
              linkedMap={linkedMap}
              setLinkedMap={setLinkedMap}
            />
          )

        })}

      </div>

<style>{`

.closeBtn{
border:none;
background:#f5f5f5;
width:32px;
height:32px;
border-radius:6px;
cursor:pointer;
}

.closeBtn:hover{
background:#eaeaea;
}

.modalHeader{
display:flex;
justify-content:space-between;
margin-bottom:10px;
}

`}</style>

    </div>

  );

}


const modalWrapper={
position:"fixed",
inset:0,
background:"rgba(0,0,0,0.05)",
display:"flex",
justifyContent:"center",
alignItems:"center",
zIndex:1000
}

const modalStyle={
width:600,
background:"#fff",
padding:20,
borderRadius:8
}